export const ABSENCE_CLASS_MAP = {
  0: 'color-holidays',
  1: 'color-sickness',
  2: 'color-maternity',
  3: 'color-family-sickness',
  4: 'color-others',
} as const;
